<template>
  <g>
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      :stroke="borderColor"
      fill="transparent"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7984 9.35306C19.827 9.32446 19.8355 9.28144 19.8201 9.24408C19.8046 9.20671 19.7681 9.18235 19.7277 9.18234L15.1921 9.18234L15.1921 3.09428C15.1921 3.06776 15.1815 3.04232 15.1628 3.02357C15.144 3.00481 15.1186 2.99428 15.0921 2.99428L8.90401 2.99428C8.87748 2.99428 8.85203 3.00483 8.83327 3.0236C8.81451 3.04237 8.80399 3.06783 8.80401 3.09437L8.80939 9.177L4.26831 9.18235C4.22789 9.18239 4.19147 9.20677 4.17602 9.24413C4.16057 9.28149 4.16913 9.32447 4.19772 9.35306L11.9273 17.0827C11.9664 17.1217 12.0297 17.1217 12.0688 17.0827L19.7984 9.35306ZM15.6214 10.9294L11.998 14.5527L8.37466 10.9294L10.451 10.9294C10.5063 10.9294 10.551 10.8846 10.551 10.8294L10.551 4.7413L13.4451 4.74129L13.4451 10.8294C13.4451 10.8846 13.4898 10.9294 13.5451 10.9294L15.6214 10.9294Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.2"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#616161"
    },

    borderColor: {
      type: String,
      default: "#616161"
    }
  }
};
</script>
